










































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// components
import SelectChannelModal from "@/components/channels/modals/SelectChannelModal.vue";
import SelectChannelGroupModal from "@/components/channels/modals/SelectChannelGroupModal.vue";
import SelectTemplateModal from "@/components/templates/modals/SelectTemplateModal.vue";
// types
import i18n from "@/i18n";
import { Content, ContentType, InteractionBehavior } from "@/services/stages/types";
import { Guid } from "guid-typescript";
import { contentFields } from "@/components/stages/fields/contentFields";
// validation
import validate from "@/directives/validate";
import {
    addContentValidators,
    removeContentValidators
} from "@/components/stages/validators";
import { ChannelStyle } from "@/services/styles/types";
import { getChannelStylesByType } from "@/services/styles/channelStylesService";
import { ChannelStyleTypes } from "@/services/channels/types";
import { Option } from "@/services/common/types";
// methods

@Component({
    components: {
        "select-channel-modal": SelectChannelModal,
        "select-channel-group-modal": SelectChannelGroupModal,
        "select-template-modal": SelectTemplateModal
    },
    directives: {
        validate
    }
})
export default class StageContent extends Vue {
    @Prop() content!: Content[];
    @Prop() collapseState!: boolean;

    // local state
    localCollapseState = true;
    localContent = [] as Content[];
    fields = contentFields;
    validators = {};
    interactionBehavior = InteractionBehavior;
    contentType = ContentType;
    behaviorTypes = Object.keys(InteractionBehavior).filter(x => (isNaN(Number(x))))
        .map(key => ({ text: i18n.t(`channels.${key}`), value: key }));

    channelBehaviorTypes = this.behaviorTypes.filter(x => x.value !== this.interactionBehavior.menuFlat);
    menuStyles: ChannelStyle[] = [];
    menuStyleOptions: Option[] = [];

    // Watchers
    @Watch("content")
    onPropertyChanged(value: boolean, oldValue: any) {
        this.localContent = this.content;
        if (this.localContent.length > 0) { }
        this.localContent.forEach(x => {
            addContentValidators(this.validators, x.id);
        });
    }

    // lifecycle hooks
    mounted() {
        this.localCollapseState = this.collapseState;
        getChannelStylesByType(ChannelStyleTypes.menuStyle).then((response: ChannelStyle[]) => {
            this.menuStyles = response;
            if (this.menuStyles.length > 0) {
                this.menuStyleOptions = this.menuStyles.map(x => ({ text: x.name, id: x.id }));
                this.menuStyleOptions.sort((a, b) => a.text.localeCompare(b.text, "en"));
            }
            this.menuStyleOptions.unshift({ id: null, text: this.$t("channels.noStyle").toString() });
        });
    }

    // computed
    get defaultMenuStyle() {
        if (this.menuStyles.length > 0) {
            const defaultStyle = this.menuStyles.filter(x => x.name.toLowerCase().includes("default"))[0];
            if (defaultStyle) return defaultStyle.id;
            else return this.menuStyles[0].id;
        }
        return null;
    }

    // methods
    addChannel() {
        (this.$refs.selectChannelModal as any).open(true);
    }

    addChannelGroup() {
        (this.$refs.selectChannelGroupModal as any).open(true);
    }

    addTemplate() {
        (this.$refs.selectTemplateModal as any).open(true);
    }

    addContent(contentId: string, contentName: string, contentType: ContentType) {
        if (!this.localContent) { this.localContent = [] as Content[]; }

        const content = {} as Content;
        content.id = Guid.create().toString();
        content.contentId = contentId;
        content.name = contentName;
        content.contentType = contentType;
        content.isDefault = this.localContent.length === 0;
        content.interactionBehavior = this.interactionBehavior.none;
        content.menuStyleId = this.defaultMenuStyle;
        content.returnToFirstPostTime = 60;
        content.showFirstPost = true;
        content.active = true;

        addContentValidators(this.validators, content.id);
        this.localContent.push(content);
    }

    deleteContent(id: string) {
        const item = this.localContent.find(x => x.id === id);
        if (!item) {
            return;
        }
        this.localContent.splice(this.localContent.indexOf(item), 1);
        this.$nextTick(() => {
            removeContentValidators(this.validators, item.id);
        });
    }

    // events && callbacks
    channelSelected(channels: any) {
        channels.forEach((channel: any) => {
            this.addContent(channel.id, channel.name, ContentType.Channel);
        });
    }

    channelGroupSelected(channelGroup: any) {
        channelGroup.forEach((channelGroup: any) => {
            this.addContent(channelGroup.id, channelGroup.name, ContentType.ChannelGroup);
        });
    }

    templateSelected(template: any) {
        template.forEach((template: any) => {
            this.addContent(template.id, template.name, ContentType.Design);
        });
    }

    emitData() {
        // deep copy to avoid binding
        this.$emit("contentUpdated", JSON.parse(JSON.stringify(this.localContent)));
    }

    setState(state: boolean) {
        if (this.localCollapseState === state) return;

        this.localCollapseState = state;
        this.$emit("componentStateChanged", { name: "StageContent", state: state });
    }

    goToContent(model: Content) {
        if (model.contentType === ContentType.Channel) {
            const route = this.$router.resolve({
                name: "updatechannel",
                params: { channelId: model.contentId }
            });
            window.open(route.href, "_blank");
        } else if (model.contentType === ContentType.ChannelGroup) {
            const route = this.$router.resolve({
                name: "UpdateChannelGroup",
                params: { channelGroupId: model.contentId }
            });
            window.open(route.href, "_blank");
        } else if (model.contentType === ContentType.Design) {
            const route = this.$router.resolve({
                name: "updatetemplate",
                params: { templateId: model.contentId }
            });
            window.open(route.href, "_blank");
        }
    }

    calculateTooltipText(model: Content) {
        if (model.contentType === ContentType.Channel) {
            return i18n.t("stage.editChannel").toString();
        }
        if (model.contentType === ContentType.ChannelGroup) {
            return i18n.t("stage.editChannelGroup").toString();
        }
        return i18n.t("stage.template").toString();
    }

    updateDefaultContent(contentId: string) {
        this.localContent.forEach(element => {
            if (element.contentId !== contentId) Vue.set(element, "isDefault", false);
        });
    }
}
